import { selectSideNavCollapsed } from '../../domain'

import { Usecase } from './Usecase'

export class NavigationUsecase extends Usecase {
    toggleSideNavCollapsed (): void {
        const sideNavCollapsed = selectSideNavCollapsed(this.getState())
        this.setState({ sideNavCollapsed: !sideNavCollapsed })
    }
}
